var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _g3, _g4, _g5, _g6, _path7, _g7, _path8, _g8, _path9, _path10, _g9, _path11, _path12, _path13, _g10, _g11, _g12, _g13, _path14, _path15, _path16, _path17, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelieve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9318 17.7192C52.1968 17.7192 57.3155 18.6096 60.9474 20.1496C63.9943 21.4489 65.1399 22.8446 65.1399 23.4221C65.1399 23.9996 63.9943 25.3952 60.9474 26.6946C57.3155 28.2346 52.2212 29.1249 46.9318 29.1249C41.6424 29.1249 36.548 28.2586 32.9405 26.7186C29.8693 25.4192 28.748 23.9996 28.748 23.4221C28.748 22.8446 29.8937 21.4489 32.9405 20.1496C36.548 18.6096 41.6668 17.7192 46.9318 17.7192ZM46.9318 14.1099C34.8662 14.1099 25.0918 18.2727 25.0918 23.4221C25.0918 28.5714 34.8662 32.7342 46.9562 32.7342C59.0462 32.7342 68.8205 28.5714 68.8205 23.4221C68.8205 18.2727 59.0218 14.1099 46.9318 14.1099Z",
    fill: "url(#paint0_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9318 17.7192C52.1968 17.7192 57.3155 18.6096 60.9474 20.1496C63.9943 21.4489 65.1399 22.8446 65.1399 23.4221C65.1399 23.9996 63.9943 25.3952 60.9474 26.6946C57.3155 28.2346 52.2212 29.1249 46.9318 29.1249C41.6424 29.1249 36.548 28.2586 32.9405 26.7186C29.8693 25.4192 28.748 23.9996 28.748 23.4221C28.748 22.8446 29.8937 21.4489 32.9405 20.1496C36.548 18.6096 41.6668 17.7192 46.9318 17.7192ZM46.9318 14.1099C34.8662 14.1099 25.0918 18.2727 25.0918 23.4221C25.0918 28.5714 34.8662 32.7342 46.9562 32.7342C59.0462 32.7342 68.8205 28.5714 68.8205 23.4221C68.8205 18.2727 59.0218 14.1099 46.9318 14.1099Z",
    fill: "url(#paint1_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9318 17.7192C52.1968 17.7192 57.3155 18.6096 60.9474 20.1496C63.9943 21.4489 65.1399 22.8446 65.1399 23.4221C65.1399 23.9996 63.9943 25.3952 60.9474 26.6946C57.3155 28.2346 52.2212 29.1249 46.9318 29.1249C41.6424 29.1249 36.548 28.2586 32.9405 26.7186C29.8693 25.4192 28.748 23.9996 28.748 23.4221C28.748 22.8446 29.8937 21.4489 32.9405 20.1496C36.548 18.6096 41.6668 17.7192 46.9318 17.7192ZM46.9318 14.1099C34.8662 14.1099 25.0918 18.2727 25.0918 23.4221C25.0918 28.5714 34.8662 32.7342 46.9562 32.7342C59.0462 32.7342 68.8205 28.5714 68.8205 23.4221C68.8205 18.2727 59.0218 14.1099 46.9318 14.1099Z",
    fill: "url(#paint2_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9318 17.7192C52.1968 17.7192 57.3155 18.6096 60.9474 20.1496C63.9943 21.4489 65.1399 22.8446 65.1399 23.4221C65.1399 23.9996 63.9943 25.3952 60.9474 26.6946C57.3155 28.2346 52.2212 29.1249 46.9318 29.1249C41.6424 29.1249 36.548 28.2586 32.9405 26.7186C29.8693 25.4192 28.748 23.9996 28.748 23.4221C28.748 22.8446 29.8937 21.4489 32.9405 20.1496C36.548 18.6096 41.6668 17.7192 46.9318 17.7192ZM46.9318 14.1099C34.8662 14.1099 25.0918 18.2727 25.0918 23.4221C25.0918 28.5714 34.8662 32.7342 46.9562 32.7342C59.0462 32.7342 68.8205 28.5714 68.8205 23.4221C68.8205 18.2727 59.0218 14.1099 46.9318 14.1099Z",
    fill: "url(#paint3_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9318 17.7192C52.1968 17.7192 57.3155 18.6096 60.9474 20.1496C63.9943 21.4489 65.1399 22.8446 65.1399 23.4221C65.1399 23.9996 63.9943 25.3952 60.9474 26.6946C57.3155 28.2346 52.2212 29.1249 46.9318 29.1249C41.6424 29.1249 36.548 28.2586 32.9405 26.7186C29.8693 25.4192 28.748 23.9996 28.748 23.4221C28.748 22.8446 29.8937 21.4489 32.9405 20.1496C36.548 18.6096 41.6668 17.7192 46.9318 17.7192ZM46.9318 14.1099C34.8662 14.1099 25.0918 18.2727 25.0918 23.4221C25.0918 28.5714 34.8662 32.7342 46.9562 32.7342C59.0462 32.7342 68.8205 28.5714 68.8205 23.4221C68.8205 18.2727 59.0218 14.1099 46.9318 14.1099Z",
    fill: "url(#paint4_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9318 17.7192C52.1968 17.7192 57.3155 18.6096 60.9474 20.1496C63.9943 21.4489 65.1399 22.8446 65.1399 23.4221C65.1399 23.9996 63.9943 25.3952 60.9474 26.6946C57.3155 28.2346 52.2212 29.1249 46.9318 29.1249C41.6424 29.1249 36.548 28.2586 32.9405 26.7186C29.8693 25.4192 28.748 23.9996 28.748 23.4221C28.748 22.8446 29.8937 21.4489 32.9405 20.1496C36.548 18.6096 41.6668 17.7192 46.9318 17.7192ZM46.9318 14.1099C34.8662 14.1099 25.0918 18.2727 25.0918 23.4221C25.0918 28.5714 34.8662 32.7342 46.9562 32.7342C59.0462 32.7342 68.8205 28.5714 68.8205 23.4221C68.8205 18.2727 59.0218 14.1099 46.9318 14.1099Z",
    fill: "url(#paint5_radial_4569_436)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9318 17.7192C52.1968 17.7192 57.3155 18.6096 60.9474 20.1496C63.9943 21.4489 65.1399 22.8446 65.1399 23.4221C65.1399 23.9996 63.9943 25.3952 60.9474 26.6946C57.3155 28.2346 52.2212 29.1249 46.9318 29.1249C41.6424 29.1249 36.548 28.2586 32.9405 26.7186C29.8693 25.4192 28.748 23.9996 28.748 23.4221C28.748 22.8446 29.8937 21.4489 32.9405 20.1496C36.548 18.6096 41.6668 17.7192 46.9318 17.7192ZM46.9318 14.1099C34.8662 14.1099 25.0918 18.2727 25.0918 23.4221C25.0918 28.5714 34.8662 32.7342 46.9562 32.7342C59.0462 32.7342 68.8205 28.5714 68.8205 23.4221C68.8205 18.2727 59.0218 14.1099 46.9318 14.1099Z",
    fill: "url(#paint6_radial_4569_436)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4618 77.6348C73.4618 77.4813 73.4312 77.3294 73.3716 77.1876C73.312 77.0459 73.2247 76.9171 73.1147 76.8087C73.0047 76.7003 72.8741 76.6144 72.7303 76.5559C72.5866 76.4974 72.4326 76.4675 72.2772 76.4678H59.3877V81.3741H69.6739C71.7653 81.3741 73.4594 79.6994 73.4594 77.6348",
    fill: "#FDEDEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4618 77.6348C73.4618 77.4813 73.4312 77.3294 73.3716 77.1876C73.312 77.0459 73.2247 76.9171 73.1147 76.8087C73.0047 76.7003 72.8741 76.6144 72.7303 76.5559C72.5866 76.4974 72.4326 76.4675 72.2772 76.4678H59.3877V81.3741H69.6739C71.7653 81.3741 73.4594 79.6994 73.4594 77.6348",
    fill: "url(#paint7_linear_4569_436)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4618 77.6348C73.4618 77.4813 73.4312 77.3294 73.3716 77.1876C73.312 77.0459 73.2247 76.9171 73.1147 76.8087C73.0047 76.7003 72.8741 76.6144 72.7303 76.5559C72.5866 76.4974 72.4326 76.4675 72.2772 76.4678H59.3877V81.3741H69.6739C71.7653 81.3741 73.4594 79.6994 73.4594 77.6348",
    fill: "url(#paint8_radial_4569_436)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4618 77.6348C73.4618 77.4813 73.4312 77.3294 73.3716 77.1876C73.312 77.0459 73.2247 76.9171 73.1147 76.8087C73.0047 76.7003 72.8741 76.6144 72.7303 76.5559C72.5866 76.4974 72.4326 76.4675 72.2772 76.4678H59.3877V81.3741H69.6739C71.7653 81.3741 73.4594 79.6994 73.4594 77.6348",
    fill: "url(#paint9_radial_4569_436)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4618 77.6348C73.4618 77.4813 73.4312 77.3294 73.3716 77.1876C73.312 77.0459 73.2247 76.9171 73.1147 76.8087C73.0047 76.7003 72.8741 76.6144 72.7303 76.5559C72.5866 76.4974 72.4326 76.4675 72.2772 76.4678H59.3877V81.3741H69.6739C71.7653 81.3741 73.4594 79.6994 73.4594 77.6348",
    fill: "url(#paint10_linear_4569_436)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2131 72.6275C77.2118 72.3097 77.0832 72.0052 76.8553 71.7807C76.6274 71.5562 76.3188 71.4298 75.9968 71.4292H59.3877V76.4679H73.3229C75.4703 76.4679 77.2131 74.7474 77.2131 72.6275Z",
    fill: "#FDEDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2131 72.6275C77.2118 72.3097 77.0832 72.0052 76.8553 71.7807C76.6274 71.5562 76.3188 71.4298 75.9968 71.4292H59.3877V76.4679H73.3229C75.4703 76.4679 77.2131 74.7474 77.2131 72.6275Z",
    fill: "url(#paint11_linear_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2131 72.6275C77.2118 72.3097 77.0832 72.0052 76.8553 71.7807C76.6274 71.5562 76.3188 71.4298 75.9968 71.4292H59.3877V76.4679H73.3229C75.4703 76.4679 77.2131 74.7474 77.2131 72.6275Z",
    fill: "url(#paint12_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2131 72.6275C77.2118 72.3097 77.0832 72.0052 76.8553 71.7807C76.6274 71.5562 76.3188 71.4298 75.9968 71.4292H59.3877V76.4679H73.3229C75.4703 76.4679 77.2131 74.7474 77.2131 72.6275Z",
    fill: "url(#paint13_radial_4569_436)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1156 67.5912C81.1149 67.2734 80.9869 66.9687 80.7595 66.7437C80.532 66.5188 80.2237 66.3918 79.9017 66.3905H59.3877V71.4292H77.2278C79.3728 71.4292 81.1156 69.7111 81.1156 67.5912Z",
    fill: "#FDEDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1156 67.5912C81.1149 67.2734 80.9869 66.9687 80.7595 66.7437C80.532 66.5188 80.2237 66.3918 79.9017 66.3905H59.3877V71.4292H77.2278C79.3728 71.4292 81.1156 69.7111 81.1156 67.5912Z",
    fill: "url(#paint14_linear_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1156 67.5912C81.1149 67.2734 80.9869 66.9687 80.7595 66.7437C80.532 66.5188 80.2237 66.3918 79.9017 66.3905H59.3877V71.4292H77.2278C79.3728 71.4292 81.1156 69.7111 81.1156 67.5912Z",
    fill: "url(#paint15_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1156 67.5912C81.1149 67.2734 80.9869 66.9687 80.7595 66.7437C80.532 66.5188 80.2237 66.3918 79.9017 66.3905H59.3877V71.4292H77.2278C79.3728 71.4292 81.1156 69.7111 81.1156 67.5912Z",
    fill: "url(#paint16_radial_4569_436)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5775 66.3905H64.377C65.7231 66.3905 66.8145 67.4678 66.8145 68.7968V78.968C66.8145 80.2969 65.7231 81.3742 64.377 81.3742H59.5775C58.2313 81.3742 57.14 80.2969 57.14 78.968V68.7968C57.14 67.4678 58.2313 66.3905 59.5775 66.3905Z",
    fill: "#F7E1ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5775 66.3905H64.377C65.7231 66.3905 66.8145 67.4678 66.8145 68.7968V78.968C66.8145 80.2969 65.7231 81.3742 64.377 81.3742H59.5775C58.2313 81.3742 57.14 80.2969 57.14 78.968V68.7968C57.14 67.4678 58.2313 66.3905 59.5775 66.3905Z",
    fill: "url(#paint17_linear_4569_436)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.541 77.6348C20.541 76.9899 21.07 76.4678 21.7232 76.4678H34.6127V81.3741H24.3265C23.3223 81.3735 22.3594 80.9792 21.6496 80.278C20.9398 79.5769 20.541 78.6261 20.541 77.6348Z",
    fill: "#E7CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.541 77.6348C20.541 76.9899 21.07 76.4678 21.7232 76.4678H34.6127V81.3741H24.3265C23.3223 81.3735 22.3594 80.9792 21.6496 80.278C20.9398 79.5769 20.541 78.6261 20.541 77.6348Z",
    fill: "url(#paint18_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.541 77.6348C20.541 76.9899 21.07 76.4678 21.7232 76.4678H34.6127V81.3741H24.3265C23.3223 81.3735 22.3594 80.9792 21.6496 80.278C20.9398 79.5769 20.541 78.6261 20.541 77.6348Z",
    fill: "url(#paint19_radial_4569_436)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7871 72.6275C16.7871 71.9658 17.3331 71.4292 18.0034 71.4292H34.6125V76.4679H20.6774C20.1666 76.4682 19.6608 76.3692 19.1888 76.1764C18.7168 75.9837 18.288 75.701 17.9267 75.3446C17.5654 74.9882 17.2788 74.565 17.0833 74.0992C16.8878 73.6334 16.7871 73.1317 16.7871 72.6275Z",
    fill: "#E7CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7871 72.6275C16.7871 71.9658 17.3331 71.4292 18.0034 71.4292H34.6125V76.4679H20.6774C20.1666 76.4682 19.6608 76.3692 19.1888 76.1764C18.7168 75.9837 18.288 75.701 17.9267 75.3446C17.5654 74.9882 17.2788 74.565 17.0833 74.0992C16.8878 73.6334 16.7871 73.1317 16.7871 72.6275Z",
    fill: "url(#paint20_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7871 72.6275C16.7871 71.9658 17.3331 71.4292 18.0034 71.4292H34.6125V76.4679H20.6774C20.1666 76.4682 19.6608 76.3692 19.1888 76.1764C18.7168 75.9837 18.288 75.701 17.9267 75.3446C17.5654 74.9882 17.2788 74.565 17.0833 74.0992C16.8878 73.6334 16.7871 73.1317 16.7871 72.6275Z",
    fill: "url(#paint21_radial_4569_436)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7871 72.6275C16.7871 71.9658 17.3331 71.4292 18.0034 71.4292H34.6125V76.4679H20.6774C20.1666 76.4682 19.6608 76.3692 19.1888 76.1764C18.7168 75.9837 18.288 75.701 17.9267 75.3446C17.5654 74.9882 17.2788 74.565 17.0833 74.0992C16.8878 73.6334 16.7871 73.1317 16.7871 72.6275Z",
    fill: "url(#paint22_radial_4569_436)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8848 67.5912C12.8848 66.9295 13.4283 66.3905 14.0986 66.3905H34.6126V71.4292H16.7726C15.7415 71.4292 14.7526 71.0248 14.0235 70.3051C13.2944 69.5853 12.8848 68.6091 12.8848 67.5912Z",
    fill: "#E7CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8848 67.5912C12.8848 66.9295 13.4283 66.3905 14.0986 66.3905H34.6126V71.4292H16.7726C15.7415 71.4292 14.7526 71.0248 14.0235 70.3051C13.2944 69.5853 12.8848 68.6091 12.8848 67.5912Z",
    fill: "#F1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8848 67.5912C12.8848 66.9295 13.4283 66.3905 14.0986 66.3905H34.6126V71.4292H16.7726C15.7415 71.4292 14.7526 71.0248 14.0235 70.3051C13.2944 69.5853 12.8848 68.6091 12.8848 67.5912Z",
    fill: "url(#paint23_linear_4569_436)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8848 67.5912C12.8848 66.9295 13.4283 66.3905 14.0986 66.3905H34.6126V71.4292H16.7726C15.7415 71.4292 14.7526 71.0248 14.0235 70.3051C13.2944 69.5853 12.8848 68.6091 12.8848 67.5912Z",
    fill: "url(#paint24_radial_4569_436)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4225 66.3905H29.623C28.2769 66.3905 27.1855 67.4678 27.1855 68.7968V78.968C27.1855 80.2969 28.2769 81.3742 29.623 81.3742H34.4225C35.7687 81.3742 36.86 80.2969 36.86 78.968V68.7968C36.86 67.4678 35.7687 66.3905 34.4225 66.3905Z",
    fill: "url(#paint25_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4225 66.3905H29.623C28.2769 66.3905 27.1855 67.4678 27.1855 68.7968V78.968C27.1855 80.2969 28.2769 81.3742 29.623 81.3742H34.4225C35.7687 81.3742 36.86 80.2969 36.86 78.968V68.7968C36.86 67.4678 35.7687 66.3905 34.4225 66.3905Z",
    fill: "url(#paint26_linear_4569_436)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5866 66.0608C26.5625 66.0857 27.5335 65.9174 28.4424 65.566C29.3514 65.2145 30.1798 64.6869 30.8789 64.0144C31.578 63.3418 32.1337 62.5379 32.5131 61.65C32.8924 60.7621 33.0879 59.8081 33.0879 58.8445C33.0879 57.8808 32.8924 56.9269 32.5131 56.039C32.1337 55.1511 31.578 54.3471 30.8789 53.6746C30.1798 53.002 29.3514 52.4744 28.4424 52.123C27.5335 51.7715 26.5625 51.6033 25.5866 51.6281C23.6805 51.6767 21.8691 52.4583 20.5383 53.8064C19.2076 55.1544 18.4629 56.9622 18.4629 58.8445C18.4629 60.7267 19.2076 62.5346 20.5383 63.8826C21.8691 65.2306 23.6805 66.0122 25.5866 66.0608Z",
    fill: "url(#paint27_linear_4569_436)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5866 66.0608C26.5625 66.0857 27.5335 65.9174 28.4424 65.566C29.3514 65.2145 30.1798 64.6869 30.8789 64.0144C31.578 63.3418 32.1337 62.5379 32.5131 61.65C32.8924 60.7621 33.0879 59.8081 33.0879 58.8445C33.0879 57.8808 32.8924 56.9269 32.5131 56.039C32.1337 55.1511 31.578 54.3471 30.8789 53.6746C30.1798 53.002 29.3514 52.4744 28.4424 52.123C27.5335 51.7715 26.5625 51.6033 25.5866 51.6281C23.6805 51.6767 21.8691 52.4583 20.5383 53.8064C19.2076 55.1544 18.4629 56.9622 18.4629 58.8445C18.4629 60.7267 19.2076 62.5346 20.5383 63.8826C21.8691 65.2306 23.6805 66.0122 25.5866 66.0608Z",
    fill: "url(#paint28_radial_4569_436)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5845 63.3297C26.7895 63.3297 27.9452 62.8572 28.7973 62.0161C29.6493 61.1749 30.128 60.0341 30.128 58.8445C30.128 57.6549 29.6493 56.5141 28.7973 55.6729C27.9452 54.8318 26.7895 54.3593 25.5845 54.3593C24.3795 54.3593 23.2238 54.8318 22.3718 55.6729C21.5197 56.5141 21.041 57.6549 21.041 58.8445C21.041 60.0341 21.5197 61.1749 22.3718 62.0161C23.2238 62.8572 24.3795 63.3297 25.5845 63.3297Z",
    fill: "#D78125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5845 63.3297C26.7895 63.3297 27.9452 62.8572 28.7973 62.0161C29.6493 61.1749 30.128 60.0341 30.128 58.8445C30.128 57.6549 29.6493 56.5141 28.7973 55.6729C27.9452 54.8318 26.7895 54.3593 25.5845 54.3593C24.3795 54.3593 23.2238 54.8318 22.3718 55.6729C21.5197 56.5141 21.041 57.6549 21.041 58.8445C21.041 60.0341 21.5197 61.1749 22.3718 62.0161C23.2238 62.8572 24.3795 63.3297 25.5845 63.3297Z",
    fill: "url(#paint29_radial_4569_436)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3229 66.0608C69.2988 66.0857 70.2698 65.9174 71.1787 65.566C72.0877 65.2145 72.9161 64.6869 73.6153 64.0144C74.3144 63.3418 74.87 62.5379 75.2494 61.65C75.6288 60.7621 75.8242 59.8081 75.8242 58.8445C75.8242 57.8808 75.6288 56.9269 75.2494 56.039C74.87 55.1511 74.3144 54.3471 73.6153 53.6746C72.9161 53.002 72.0877 52.4744 71.1787 52.123C70.2698 51.7715 69.2988 51.6033 68.3229 51.6281C66.4169 51.6767 64.6054 52.4583 63.2747 53.8064C61.944 55.1544 61.1992 56.9622 61.1992 58.8445C61.1992 60.7267 61.944 62.5346 63.2747 63.8826C64.6054 65.2306 66.4169 66.0122 68.3229 66.0608Z",
    fill: "url(#paint30_linear_4569_436)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3229 66.0608C69.2988 66.0857 70.2698 65.9174 71.1787 65.566C72.0877 65.2145 72.9161 64.6869 73.6153 64.0144C74.3144 63.3418 74.87 62.5379 75.2494 61.65C75.6288 60.7621 75.8242 59.8081 75.8242 58.8445C75.8242 57.8808 75.6288 56.9269 75.2494 56.039C74.87 55.1511 74.3144 54.3471 73.6153 53.6746C72.9161 53.002 72.0877 52.4744 71.1787 52.123C70.2698 51.7715 69.2988 51.6033 68.3229 51.6281C66.4169 51.6767 64.6054 52.4583 63.2747 53.8064C61.944 55.1544 61.1992 56.9622 61.1992 58.8445C61.1992 60.7267 61.944 62.5346 63.2747 63.8826C64.6054 65.2306 66.4169 66.0122 68.3229 66.0608Z",
    fill: "url(#paint31_radial_4569_436)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3229 66.0608C69.2988 66.0857 70.2698 65.9174 71.1787 65.566C72.0877 65.2145 72.9161 64.6869 73.6153 64.0144C74.3144 63.3418 74.87 62.5379 75.2494 61.65C75.6288 60.7621 75.8242 59.8081 75.8242 58.8445C75.8242 57.8808 75.6288 56.9269 75.2494 56.039C74.87 55.1511 74.3144 54.3471 73.6153 53.6746C72.9161 53.002 72.0877 52.4744 71.1787 52.123C70.2698 51.7715 69.2988 51.6033 68.3229 51.6281C66.4169 51.6767 64.6054 52.4583 63.2747 53.8064C61.944 55.1544 61.1992 56.9622 61.1992 58.8445C61.1992 60.7267 61.944 62.5346 63.2747 63.8826C64.6054 65.2306 66.4169 66.0122 68.3229 66.0608Z",
    fill: "url(#paint32_radial_4569_436)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3231 63.4669C69.5649 63.4669 70.7559 62.9799 71.634 62.113C72.5122 61.2461 73.0055 60.0704 73.0055 58.8445C73.0055 57.6185 72.5122 56.4428 71.634 55.5759C70.7559 54.7091 69.5649 54.222 68.3231 54.222C67.0812 54.222 65.8902 54.7091 65.0121 55.5759C64.134 56.4428 63.6406 57.6185 63.6406 58.8445C63.6406 60.0704 64.134 61.2461 65.0121 62.113C65.8902 62.9799 67.0812 63.4669 68.3231 63.4669Z",
    fill: "url(#paint33_linear_4569_436)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2142 27.6739C59.7757 25.1107 55.5888 23.7161 51.2802 23.6987H42.7197C38.4103 23.7156 34.2223 25.1102 30.7832 27.6739C24.8406 32.0917 21.6256 39.4428 22.3617 46.972L24.3799 64.9804C25.0454 71.9537 29.7278 77.8153 36.2237 79.8149C43.2424 81.9676 50.7575 81.9676 57.7761 79.8149C64.2721 77.8177 68.9545 71.9537 69.6175 64.9804L71.6406 46.972C72.3719 39.4428 69.1592 32.0917 63.2142 27.6739Z",
    fill: "url(#paint34_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2142 27.6739C59.7757 25.1107 55.5888 23.7161 51.2802 23.6987H42.7197C38.4103 23.7156 34.2223 25.1102 30.7832 27.6739C24.8406 32.0917 21.6256 39.4428 22.3617 46.972L24.3799 64.9804C25.0454 71.9537 29.7278 77.8153 36.2237 79.8149C43.2424 81.9676 50.7575 81.9676 57.7761 79.8149C64.2721 77.8177 68.9545 71.9537 69.6175 64.9804L71.6406 46.972C72.3719 39.4428 69.1592 32.0917 63.2142 27.6739Z",
    fill: "url(#paint35_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2142 27.6739C59.7757 25.1107 55.5888 23.7161 51.2802 23.6987H42.7197C38.4103 23.7156 34.2223 25.1102 30.7832 27.6739C24.8406 32.0917 21.6256 39.4428 22.3617 46.972L24.3799 64.9804C25.0454 71.9537 29.7278 77.8153 36.2237 79.8149C43.2424 81.9676 50.7575 81.9676 57.7761 79.8149C64.2721 77.8177 68.9545 71.9537 69.6175 64.9804L71.6406 46.972C72.3719 39.4428 69.1592 32.0917 63.2142 27.6739Z",
    fill: "url(#paint36_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2142 27.6739C59.7757 25.1107 55.5888 23.7161 51.2802 23.6987H42.7197C38.4103 23.7156 34.2223 25.1102 30.7832 27.6739C24.8406 32.0917 21.6256 39.4428 22.3617 46.972L24.3799 64.9804C25.0454 71.9537 29.7278 77.8153 36.2237 79.8149C43.2424 81.9676 50.7575 81.9676 57.7761 79.8149C64.2721 77.8177 68.9545 71.9537 69.6175 64.9804L71.6406 46.972C72.3719 39.4428 69.1592 32.0917 63.2142 27.6739Z",
    fill: "url(#paint37_linear_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2142 27.6739C59.7757 25.1107 55.5888 23.7161 51.2802 23.6987H42.7197C38.4103 23.7156 34.2223 25.1102 30.7832 27.6739C24.8406 32.0917 21.6256 39.4428 22.3617 46.972L24.3799 64.9804C25.0454 71.9537 29.7278 77.8153 36.2237 79.8149C43.2424 81.9676 50.7575 81.9676 57.7761 79.8149C64.2721 77.8177 68.9545 71.9537 69.6175 64.9804L71.6406 46.972C72.3719 39.4428 69.1592 32.0917 63.2142 27.6739Z",
    fill: "url(#paint38_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2142 27.6739C59.7757 25.1107 55.5888 23.7161 51.2802 23.6987H42.7197C38.4103 23.7156 34.2223 25.1102 30.7832 27.6739C24.8406 32.0917 21.6256 39.4428 22.3617 46.972L24.3799 64.9804C25.0454 71.9537 29.7278 77.8153 36.2237 79.8149C43.2424 81.9676 50.7575 81.9676 57.7761 79.8149C64.2721 77.8177 68.9545 71.9537 69.6175 64.9804L71.6406 46.972C72.3719 39.4428 69.1592 32.0917 63.2142 27.6739Z",
    fill: "url(#paint39_radial_4569_436)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9364 68.1999C44.4502 68.1999 42.1199 67.5984 40.1724 66.5733C39.4996 66.2172 38.783 66.9728 39.2095 67.62C40.042 68.9037 41.1878 69.9602 42.5417 70.6927C43.8957 71.4251 45.4144 71.8099 46.9584 71.8117C50.2051 71.8117 53.0521 70.1394 54.7096 67.62C55.1118 66.9944 54.4171 66.2388 53.7444 66.5733C51.6403 67.6474 49.3051 68.2054 46.9364 68.1999Z",
    stroke: "url(#paint40_radial_4569_436)",
    strokeWidth: 0.2
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9364 68.1999C44.4502 68.1999 42.1199 67.5984 40.1724 66.5733C39.4996 66.2172 38.783 66.9728 39.2095 67.62C40.042 68.9037 41.1878 69.9602 42.5417 70.6927C43.8957 71.4251 45.4144 71.8099 46.9584 71.8117C50.2051 71.8117 53.0521 70.1394 54.7096 67.62C55.1118 66.9944 54.4171 66.2388 53.7444 66.5733C51.6403 67.6474 49.3051 68.2054 46.9364 68.1999Z",
    fill: "#8A034F"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5475 52.8722C59.2747 52.8737 60.9518 53.4447 62.3128 54.4944C63.6738 55.5441 64.6406 57.0125 65.0599 58.6664C65.1165 58.8886 65.1207 59.1206 65.0724 59.3447C65.0241 59.5688 64.9245 59.779 64.7813 59.9592C64.638 60.1394 64.4549 60.2849 64.2459 60.3845C64.0369 60.484 63.8075 60.5351 63.5755 60.5337H51.2052C51.0175 60.5343 50.832 60.494 50.6618 60.4158C50.4917 60.3376 50.3411 60.2233 50.2208 60.0811C50.1004 59.9389 50.0134 59.7722 49.9657 59.593C49.918 59.4138 49.911 59.2264 49.945 59.0442C50.2922 57.3051 51.2404 55.7389 52.6274 54.6133C54.0145 53.4876 55.7519 52.8722 57.5475 52.8722ZM35.0567 52.8722C33.3292 52.8732 31.6515 53.4439 30.29 54.4936C28.9285 55.5434 27.9613 57.0121 27.5419 58.6664C27.4853 58.8888 27.4811 59.1211 27.5295 59.3453C27.578 59.5696 27.6778 59.7799 27.8213 59.9602C27.9649 60.1404 28.1483 60.2858 28.3576 60.3853C28.5669 60.4847 28.7965 60.5355 29.0288 60.5337H41.3991C41.5866 60.5339 41.7718 60.4934 41.9417 60.415C42.1115 60.3367 42.2618 60.2223 42.3819 60.0802C42.5019 59.938 42.5888 59.7715 42.6363 59.5924C42.6838 59.4134 42.6908 59.2262 42.6569 59.0442C42.3055 57.308 41.3569 55.7451 39.9718 54.6202C38.5867 53.4954 36.8503 52.8778 35.0567 52.8722Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4012 54.3593C57.1621 54.36 57.9125 54.5339 58.5941 54.8675C59.2758 55.2011 59.8704 55.6854 60.3316 56.2827C60.7929 56.88 61.1084 57.5743 61.2536 58.3116C61.3988 59.0489 61.3699 59.8093 61.169 60.5337H51.6091C51.4901 60.1138 51.4294 59.6799 51.4287 59.2439C51.4287 56.5586 53.6566 54.3593 56.4012 54.3593Z",
    fill: "url(#paint41_radial_4569_436)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2021 54.3593C35.4413 54.36 34.6909 54.5339 34.0092 54.8675C33.3275 55.2011 32.733 55.6854 32.2717 56.2827C31.8105 56.88 31.495 57.5743 31.3498 58.3116C31.2045 59.0489 31.2335 59.8093 31.4344 60.5337H40.9943C41.1064 60.1102 41.1746 59.6891 41.1746 59.2439C41.1656 57.947 40.6381 56.7061 39.7068 55.7913C38.7755 54.8764 37.5159 54.3618 36.2021 54.3593Z",
    fill: "url(#paint42_radial_4569_436)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5663 59.2439C53.5663 57.6895 54.8265 56.4479 56.4011 56.4479C57.9757 56.4479 59.2359 57.6895 59.2359 59.2439C59.2359 59.7107 59.1238 60.1559 58.919 60.5313H53.9051C53.6777 60.1397 53.5607 59.6952 53.5663 59.2439ZM39.0363 59.2439C39.0363 57.6895 37.7761 56.4479 36.2015 56.4479C34.6269 56.4479 33.3691 57.6895 33.3691 59.2439C33.3691 59.7107 33.4813 60.1559 33.6836 60.5337H38.7C38.9023 60.1559 39.0363 59.7107 39.0363 59.2439Z",
    fill: "black"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2871 48.476C33.6155 48.0091 35.4583 47.6771 37.8446 47.8985",
    stroke: "#C15231",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4111 48.2666C33.7396 47.7998 35.5823 47.4677 37.9686 47.6891",
    stroke: "#C45B41",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5643 48.476C59.2359 48.0091 57.3907 47.6771 55.0068 47.8985",
    stroke: "#C15231",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5643 48.1511C59.2359 47.6843 57.3907 47.3523 55.0068 47.5736",
    stroke: "#C45B41",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4973 21.1024C44.1823 20.6067 41.2719 21.3454 39.3975 23.819C40.686 23.7055 41.9833 23.7329 43.2658 23.9008L43.568 23.9417C47.2316 24.4422 49.6788 28.4872 49.1499 32.0989C48.9179 33.6639 48.1237 35.0944 46.9123 36.1294C46.7242 36.2843 46.5934 36.4963 46.5402 36.7323C46.487 36.9684 46.5145 37.2151 46.6183 37.4341C46.7221 37.6531 46.8965 37.832 47.1141 37.9429C47.3318 38.0538 47.5805 38.0905 47.8215 38.0472C49.6089 37.7079 51.2437 36.8238 52.4955 35.5194C53.7474 34.2149 54.5534 32.5558 54.8 30.7755C55.4703 26.1435 52.1821 21.805 47.4948 21.1024",
    fill: "url(#paint43_linear_4569_436)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5493 19.3314C44.806 19.3103 43.0898 19.7581 41.5847 20.6266C40.0797 21.4952 38.8425 22.7519 38.0059 24.2618C39.3925 23.9473 40.8098 23.7835 42.2325 23.7733H42.5713C46.6419 23.7733 50.0617 27.0603 50.0374 31.0787C50.028 32.82 49.3813 34.4993 48.2165 35.807C48.0347 36.0035 47.924 36.2539 47.9018 36.5191C47.8795 36.7843 47.9469 37.0493 48.0935 37.2726C48.24 37.4959 48.4574 37.665 48.7117 37.7534C48.966 37.8417 49.2427 37.8443 49.4987 37.7609C51.3967 37.125 53.0449 35.9174 54.2111 34.3081C55.3773 32.6989 56.0028 30.769 55.9995 28.7904C56.0239 23.641 51.7704 19.3988 46.5517 19.3338",
    fill: "#E99628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5493 19.3314C44.806 19.3103 43.0898 19.7581 41.5847 20.6266C40.0797 21.4952 38.8425 22.7519 38.0059 24.2618C39.3925 23.9473 40.8098 23.7835 42.2325 23.7733H42.5713C46.6419 23.7733 50.0617 27.0603 50.0374 31.0787C50.028 32.82 49.3813 34.4993 48.2165 35.807C48.0347 36.0035 47.924 36.2539 47.9018 36.5191C47.8795 36.7843 47.9469 37.0493 48.0935 37.2726C48.24 37.4959 48.4574 37.665 48.7117 37.7534C48.966 37.8417 49.2427 37.8443 49.4987 37.7609C51.3967 37.125 53.0449 35.9174 54.2111 34.3081C55.3773 32.6989 56.0028 30.769 55.9995 28.7904C56.0239 23.641 51.7704 19.3988 46.5517 19.3338",
    fill: "url(#paint44_radial_4569_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5493 19.3314C44.806 19.3103 43.0898 19.7581 41.5847 20.6266C40.0797 21.4952 38.8425 22.7519 38.0059 24.2618C39.3925 23.9473 40.8098 23.7835 42.2325 23.7733H42.5713C46.6419 23.7733 50.0617 27.0603 50.0374 31.0787C50.028 32.82 49.3813 34.4993 48.2165 35.807C48.0347 36.0035 47.924 36.2539 47.9018 36.5191C47.8795 36.7843 47.9469 37.0493 48.0935 37.2726C48.24 37.4959 48.4574 37.665 48.7117 37.7534C48.966 37.8417 49.2427 37.8443 49.4987 37.7609C51.3967 37.125 53.0449 35.9174 54.2111 34.3081C55.3773 32.6989 56.0028 30.769 55.9995 28.7904C56.0239 23.641 51.7704 19.3988 46.5517 19.3338",
    fill: "url(#paint45_radial_4569_436)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6584 66.0584C47.804 66.0584 48.8277 65.4376 49.4127 64.5015C49.949 63.6449 49.3884 62.502 48.4134 62.502H44.9034C43.9284 62.502 43.3434 63.6714 43.904 64.5015C44.489 65.464 45.5127 66.0584 46.6584 66.0584Z",
    fill: "#F1902D"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9611 65.2836C48.1067 65.2836 49.1305 64.6579 49.7155 63.7243C50.2517 62.8677 49.6911 61.7247 48.7161 61.7247H45.2061C44.2311 61.7247 43.6461 62.8942 44.2067 63.7243C44.7917 64.6868 45.8155 65.2836 46.9611 65.2836Z",
    fill: "url(#paint46_radial_4569_436)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0362 55.3915C56.3896 55.8583 55.6535 56.4262 54.815 57.0446C53.9765 57.663 53.3549 58.0986 53.0039 57.6317C52.6505 57.1673 53.0429 56.2891 53.8814 55.6682C54.7199 55.0474 55.6852 54.9271 56.0362 55.3915Z",
    fill: "#C7A7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0362 55.3915C56.3896 55.8583 55.6535 56.4262 54.815 57.0446C53.9765 57.663 53.3549 58.0986 53.0039 57.6317C52.6505 57.1673 53.0429 56.2891 53.8814 55.6682C54.7199 55.0474 55.6852 54.9271 56.0362 55.3915Z",
    fill: "url(#paint47_radial_4569_436)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8086 58.6014C60.6637 57.6441 60.2148 56.7569 59.5265 56.0676L58.0859 57.6317L58.7368 58.8781L60.8086 58.6014Z",
    fill: "url(#paint48_linear_4569_436)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7233 58.6713C40.7233 57.0928 39.4217 56.0388 39.0707 55.7212L37.4717 57.2492L38.4564 59.2271L40.7233 58.6713Z",
    fill: "url(#paint49_linear_4569_436)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_4569_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2202 57.4026C36.2741 56.8513 36.8991 55.9771 36.6162 55.4498C36.3332 54.9225 35.2494 54.9419 34.1955 55.4932C33.1415 56.0444 32.5165 56.9186 32.7995 57.4459C33.0824 57.9732 34.1662 57.9538 35.2202 57.4026Z",
    fill: "#C7A7A3",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2202 57.4026C36.2741 56.8513 36.8991 55.9771 36.6162 55.4498C36.3332 54.9225 35.2494 54.9419 34.1955 55.4932C33.1415 56.0444 32.5165 56.9186 32.7995 57.4459C33.0824 57.9732 34.1662 57.9538 35.2202 57.4026Z",
    fill: "url(#paint50_radial_4569_436)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4569_436",
    x: 25.0918,
    y: 13.9099,
    width: 43.7285,
    height: 18.8244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.596078 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4569_436",
    x: 59.2877,
    y: 71.4292,
    width: 17.9252,
    height: 5.1387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.768627 0 0 0 0 0.729412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4569_436",
    x: 59.2877,
    y: 66.3905,
    width: 21.8275,
    height: 5.1387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.768627 0 0 0 0 0.729412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_4569_436",
    x: 57.1396,
    y: 65.9905,
    width: 10.0748,
    height: 15.3838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.4,
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.639216 0 0 0 0 0.54902 0 0 0 0 0.713726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_4569_436",
    x: 20.041,
    y: 76.0678,
    width: 14.5713,
    height: 5.30637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.635294 0 0 0 0 0.541176 0 0 0 0 0.717647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_4569_436",
    x: 16.2871,
    y: 71.0292,
    width: 18.3252,
    height: 5.4387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.780392 0 0 0 0 0.694118 0 0 0 0 0.776471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_4569_436",
    x: 12.3848,
    y: 65.9905,
    width: 22.2275,
    height: 5.4387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.780392 0 0 0 0 0.694118 0 0 0 0 0.776471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_4569_436",
    x: 26.7855,
    y: 65.9905,
    width: 10.0748,
    height: 15.3838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.4,
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.54902 0 0 0 0 0.709804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_4569_436",
    x: 20.791,
    y: 54.1093,
    width: 9.58691,
    height: 9.47046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_4569_436",
    x: 63.3906,
    y: 53.972,
    width: 9.86523,
    height: 9.74487,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_4569_436",
    x: 22.2578,
    y: 23.6987,
    width: 50.7354,
    height: 57.7307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.639216 0 0 0 0 0.352941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_4569_436",
    x: 38.8795,
    y: 66.2821,
    width: 16.1502,
    height: 5.72966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_4569_436",
    x: 39.0811,
    y: 66.4819,
    width: 15.7471,
    height: 5.32983,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.529412 0 0 0 0 0 0 0 0 0 0.301961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_4569_436",
    x: 31.7871,
    y: 47.0282,
    width: 6.80762,
    height: 1.94783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.235294 0 0 0 0 0.156863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_4569_436",
    x: 32.0607,
    y: 47.2689,
    width: 6.25742,
    height: 1.34775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_4569_436",
    x: 54.2568,
    y: 47.0282,
    width: 6.80762,
    height: 1.94783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.235294 0 0 0 0 0.156863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_4569_436",
    x: 54.6564,
    y: 47.1534,
    width: 6.2584,
    height: 1.34775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_4569_436",
    x: 38.8975,
    y: 20.4569,
    width: 16.4893,
    height: 18.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_4569_436",
    x: 38.0059,
    y: 19.1307,
    width: 18.1941,
    height: 18.691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847059 0 0 0 0 0.458824 0 0 0 0 0.0117647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_4569_436",
    x: 43.1855,
    y: 62.002,
    width: 6.93555,
    height: 4.5564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_4569_436",
    x: 43.7383,
    y: 61.4747,
    width: 6.43555,
    height: 4.05884,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_4569_436",
    x: 52.774,
    y: 55.0094,
    width: 3.45293,
    height: 2.91838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_4569_436",
    x: 57.8859,
    y: 55.8676,
    width: 3.12266,
    height: 3.21055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_4569_436",
    x: 37.2717,
    y: 55.5212,
    width: 3.65195,
    height: 3.90586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_4569_436",
    x: 32.6314,
    y: 54.9667,
    width: 4.15313,
    height: 2.96233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05,
    result: "effect1_foregroundBlur_4569_436"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.0315 17.1947) rotate(101.642) scale(9.05943 24.1681)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33AED4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8694 26.8949) rotate(-57.1138) scale(12.6258 25.8381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D8DB9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9534 25.8427) rotate(47.1764) scale(4.81857 3.66417)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#5BBFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BBFD1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.1721 26.9328) rotate(-136.701) scale(3.45386 2.06224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47C2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47C2D5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.7085 27.7605) rotate(145.667) scale(7.93289 5.69966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#4997C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4997C1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.0726 25.0907) rotate(144.953) scale(3.53557 2.54103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#439FB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439FB2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5627 32.7342) rotate(-105.106) scale(18.122 46.7327)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#43ACC0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43ACC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4569_436",
    x1: 67.9263,
    y1: 81.9107,
    x2: 67.9263,
    y2: 78.3134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.079,
    stopColor: "#9A84AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B7CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.8884 75.5342) rotate(76.9218) scale(6.54078 11.7603)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CEBFD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#A797B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.4594 76.7421) rotate(131.109) scale(1.94387 1.0748)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F1F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4569_436",
    x1: 67.5631,
    y1: 76.4678,
    x2: 67.5631,
    y2: 77.4255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEEEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4569_436",
    x1: 70.2004,
    y1: 76.4679,
    x2: 70.2004,
    y2: 73.9485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#C6BEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4C7CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.6867 70.4715) rotate(74.0103) scale(6.80528 14.7003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CEBFD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#A797B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.2131 71.7131) rotate(137.107) scale(2.20958 1.22972)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F1F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4569_436",
    x1: 72.5697,
    y1: 71.4292,
    x2: 72.5697,
    y2: 68.9098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#D3C5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4C7CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.5995 65.4328) rotate(70.7454) scale(6.92962 17.5983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#CEBFD0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#A89BB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.1156 66.672) rotate(142.688) scale(2.48108 1.33502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F1F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4569_436",
    x1: 66.8145,
    y1: 79.3794,
    x2: 64.4793,
    y2: 79.3794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EFF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4793 77.8778) rotate(111.878) scale(4.49723 3.59773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#AF9ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF9ABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4898 81.788) rotate(-75.9336) scale(5.48453 13.5471)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#E7CBD8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFA9AD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4012 72.3869) rotate(110.093) scale(5.76492 5.75267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#CFB6BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFB6BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7898 76.8931) rotate(-69.4189) scale(5.83518 17.2314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#D3B6B4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3B6B4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2154 69.9806) rotate(108.987) scale(8.11125 13.3846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#B0A1BB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#B0A1BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4569_436",
    x1: 23.7487,
    y1: 66.3905,
    x2: 23.7487,
    y2: 68.5152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D3D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5001 64.9443) rotate(109.591) scale(8.85958 17.178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#B0A1BB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986,
    stopColor: "#B0A1BB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6764 74.8712) rotate(122.735) scale(4.64842 7.61453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7B5CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCBDC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4569_436",
    x1: 27.1855,
    y1: 79.3818,
    x2: 30.2397,
    y2: 79.3818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAC4CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4569_436",
    x1: 19.232,
    y1: 58.8445,
    x2: 25.5853,
    y2: 58.2742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE8D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB773F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5875 59.8865) rotate(-157.944) scale(9.0549 11.6742)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#CE9F45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5845 58.8445) rotate(90) scale(4.48457 4.54282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#CE791D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE791D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4569_436",
    x1: 74.0584,
    y1: 53.2235,
    x2: 69.106,
    y2: 64.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.1021 56.2075) rotate(90.9613) scale(10.4794 10.1732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#D58651",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D58651"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.1029 57.9421) rotate(-48.7715) scale(5.81256 5.74601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFB61F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#FFB61F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4569_436",
    x1: 71.0726,
    y1: 61.4119,
    x2: 71.7901,
    y2: 54.5738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#FFC332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD165"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.9528 44.378) rotate(90) scale(38.6475 28.5753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#FFE944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDAB24"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8143 81.4295) rotate(-52.2613) scale(11.714 25.9468)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D17C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D17C51",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9999 82.8877) rotate(-90) scale(7.42472 34.6717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D87A77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D87A77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4569_436",
    x1: 23.7047,
    y1: 60.7526,
    x2: 38.0446,
    y2: 60.7526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB992C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB992C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.4635 56.3804) rotate(-64.4559) scale(7.49848 8.4863)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#FFBA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2871 57.006) rotate(-65.4169) scale(7.09648 7.87657)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#F0953D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0953D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.9883 70.3896) rotate(-51.3307) scale(3.14389 7.7229)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.389 58.255) rotate(90) scale(3.15724 5.08716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#8F564F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86534B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2143 58.255) rotate(90) scale(3.15724 5.08716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#8F564F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86534B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4569_436",
    x1: 53.0012,
    y1: 25.0366,
    x2: 45.71,
    y2: 37.8783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07F05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0034 30.2871) rotate(-14.7409) scale(18.1922 15.0072)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#FFD937",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FFD937"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6385 33.0849) rotate(-123.101) scale(14.9827 15.5286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#C9983D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#C9983D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5209 62.3215) rotate(118.02) scale(4.5004 6.85306)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#FFE245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29624"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1246 57.432) rotate(-128.171) scale(2.0808 2.87373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#FFE6E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4569_436",
    x1: 60.7038,
    y1: 57.2659,
    x2: 58.9759,
    y2: 58.3446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4569_436",
    x1: 40.3382,
    y1: 57.266,
    x2: 38.6102,
    y2: 58.3447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4948D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4948D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_4569_436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4516 58.0086) rotate(-119.124) scale(2.71287 3.28339)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#FFE6E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#FFE6E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelieve);
export default __webpack_public_path__ + "static/media/believe.ec530b6ca7b25d634817f59896fb6910.svg";
export { ForwardRef as ReactComponent };